import { useAppSelector, useAppTranslation } from "@/utils";
import { Close } from "@payping/icons";
import { Button, Drawer } from "@payping/web-components";
import { FC } from "react";
import { ActivationSteps } from "@payping/api/app/api/bnplMerchantTypes";
import BnplActivationPageFormLayout from "./Layout";
import BnplActivationPageFormInitSetting from "./InitSettings";
import BnplActivationPageFormInformationCompleting from "./InformationCompleting";
import BnplActivationPageFormSignature from "./Signature";
import { useAtom } from "jotai";
import { installmentPaymentAtom } from "../../state";
import { selectAtom } from "jotai/utils";
import { useImmerAtom } from "jotai-immer";

const activationStepAtom = selectAtom(installmentPaymentAtom, (val) => val.bnplActivationStep);

interface Props {
  open: boolean;
  onClose: () => void;
  onDone: () => void;
}
const BnplActivationPageForm: FC<Props> = ({ onClose, open, onDone }) => {
  const { t } = useAppTranslation();

  const [activationStepSate] = useAtom(activationStepAtom);
  const [, setInstallmentPaymentState] = useImmerAtom(installmentPaymentAtom);

  const contract = useAppSelector((state) => state.bnplMerchant.contract);

  if (!open) {
    return null;
  }
  return (
    <Drawer
      closeIcon={false}
      height={"100%"}
      width={"100%"}
      placement="bottom"
      open={open}
      onClose={onClose}
      title={t("shop.bnpl.activation.formDrawer.title")}
      extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={onClose} />}
      classNames={{ body: "!tw-p-0" }}
    >
      <BnplActivationPageFormLayout>
        {activationStepSate === ActivationSteps.SetWalletCreditAmount ? (
          <BnplActivationPageFormInitSetting
            onFinish={(as) => {
              setInstallmentPaymentState((draft) => {
                draft.bnplActivationStep = as;
              });
            }}
            // goBack={(as) => {
            //   setInstallmentPaymentState((draft) => {
            //     draft.bnplActivationStep = as;
            //   });
            // }}
          />
        ) : null}
        {activationStepSate === ActivationSteps.CompleteMerchantProfileInfo ? (
          <BnplActivationPageFormInformationCompleting
            onFinish={() => {
              if (!contract?.hasValidSignature) {
                setInstallmentPaymentState((draft) => {
                  draft.bnplActivationStep = ActivationSteps.UploadSignature;
                });
                return;
              }

              if (contract?.hasValidSignature) {
                setInstallmentPaymentState((draft) => {
                  draft.bnplActivationStep = ActivationSteps.WaitingForAdmin;
                });
                onDone();
              }
            }}
            goBack={() => {
              setInstallmentPaymentState((draft) => {
                draft.bnplActivationStep = ActivationSteps.SetWalletCreditAmount;
              });
            }}
          />
        ) : null}
        {activationStepSate === ActivationSteps.UploadSignature ? (
          <BnplActivationPageFormSignature
            onFinish={() => {
              setInstallmentPaymentState((draft) => {
                draft.bnplActivationStep = ActivationSteps.WaitingForAdmin;
              });
              onDone();
            }}
            goBack={() => {
              setInstallmentPaymentState((draft) => {
                draft.bnplActivationStep = ActivationSteps.CompleteMerchantProfileInfo;
              });
            }}
          />
        ) : null}
        {/* {activationStep === ActivationSteps.AcceptRegulations ? (
          <BnplActivationPageFormRules
            onFinish={() => {
              setInstallmentPaymentState((draft) => {
                draft.bnplActivationStep = ActivationSteps.WaitingForAdmin;
              });
              onDone();
            }}
          />
        ) : null} */}
      </BnplActivationPageFormLayout>
    </Drawer>
  );
};

export default BnplActivationPageForm;
